import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "weight-warning.svg",
  "use": "weight-warning.svg-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 24 24\" id=\"weight-warning.svg\"><defs><path d=\"M5.68 20c-1.293 0-2.099-1.571-1.452-2.822l6.32-12.24c.646-1.25 2.258-1.25 2.904 0l6.32 12.24c.647 1.25-.16 2.822-1.452 2.822H5.68zM12 13c.55 0 1-.45 1-1v-2c0-.55-.45-1-1-1s-1 .45-1 1v2c0 .55.45 1 1 1zm0 4a1 1 0 1 0 0-2 1 1 0 0 0 0 2z\" id=\"weight-warning.svg_a\" /></defs><use xlink:href=\"#weight-warning.svg_a\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol